import React from 'react'
import MaterialSymbol from '../material-symbol'

const PinDrop = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="pin_drop" {...props} />
))

PinDrop.displayName = 'PinDrop'

export default PinDrop
